/*
  Author: Surojit Basu
  Date: June 01, 2020
*/

import React , {useEffect } from 'react';
import './App.css';
import Routes from './Routes';

import { BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom";

import {UserProvider} from './contexts/UserContext';

import Utils from './Utils';
import NotFound from './components/NotFound';


const App = (props) => {

  const RoutedLayout = () => {
    return <Router basename={process.env.REACT_APP_BASENAME || ""}>
      <Switch>
        {Routes.map((route, index) => {
          if(route.secure && !Utils.isLoggedIn()){
            return <Redirect  key={index} to={`${process.env.PUBLIC_URL}/login`} />
          }else{
            return (
              <Route
                key={index}
                path={process.env.PUBLIC_URL + route.path}
                exact={route.exact || false}
                component={() => <route.layout {...props}>
                      <route.component {...props} />
                    </route.layout>}
              />
            );
          }
        })}
		<Route component={NotFound}></Route>
      </Switch>
    </Router>
  }
  
  const Provider = () => {
    return <UserProvider>
      <RoutedLayout />
    </UserProvider>;
  }

  return <Provider />;
}

export default App;
